import { TmBaseComponent } from '@treasury/presentation';
import { css, type TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';

export const tagName = 'jhd-icon';
@customElement(tagName)
export class JhdIcon extends TmBaseComponent {
    @property({ type: Object })
    public icon!: TemplateResult<2>;

    @property()
    public width = '';

    @property()
    public height = '';

    @property()
    public color = '';

    protected firstUpdated() {
        this.setIconColor();
        this.setIconSize();
    }

    protected updated() {
        this.setIconColor();
        this.setIconSize();
    }

    protected render() {
        return this.icon;
    }

    private setIconSize() {
        const svg = this.shadowRoot?.querySelector('svg');
        if (svg) {
            svg.style.width = this.width;
            svg.style.height = this.height;
        }
    }

    private setIconColor() {
        const path = this.shadowRoot?.querySelector('path');
        if (this.color && path) {
            path.style.fill = this.color;
        }
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: inline-block;
                }
                path {
                    fill: var(--icon-fill-color, var(--brand-primary));
                }
                svg {
                    transform: var(--icon-svg-transform, scale(1));
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: JhdIcon;
    }
}
